import React from 'react'
import { b64EncodeUnicode } from '../utils/Tools'
import { handleBundleCheckboxClick } from '../utils/BundleUtils'
import { ReactComponent as Check } from '../assets/check.svg'
import { isScanRequired } from '../utils/ScanRequirementUtils'

export default function printBundle(product, parent, group_treshold, toggleConfirmButton) {
  const { product_confirmation_method, scan_bundle_element_as_single_qty, bundle_select } = parent.props
  let product_uom_qty = product.product_uom_qty
  if(product.product_uom_qty < group_treshold){
    product_uom_qty = 1
  }
  return (
    <div className={`ramka bundleItemList${bundle_select ? ' locked' : ''}`}>
      <table>
        <tbody>
          {product.items.map((item, index) => {
            const barcodeString = '#' + (item.barcode || '') + '#' + 
              (item.additional_barcodes_ids || []).map(item => 
                typeof item === 'object' ? item.barcode : item
              ).join('#') + '#'
            const destinationQty = product_uom_qty * item.qty_uom;
            const scanRequired = isScanRequired(parent.props, item);
            return (<tr className='bundleItem' data-barcode={barcodeString} data-product-id={item.id} data-scan-required={scanRequired ? '1' : '0'} data-name={b64EncodeUnicode(item.product_name || '')} data-code={item.default_code || ''} data-qty={item.qty_uom} key={`${product.line_id}_${index}`}>
              <td>
                [{item.default_code || ''}] {item.name}
              </td>
              <td className="width1 smaller-counter-wrapper">
                <span className="smaller">{product_uom_qty} x {item.qty_uom} = </span>
                {destinationQty} szt.
                {scan_bundle_element_as_single_qty && (
                    <span className="smaller counter"
                      data-count="0"
                      data-qty-uom={destinationQty}
                      data-destination={destinationQty}>
                      <span className="current-count">0</span> / {destinationQty}
                    </span>
                  )}
              </td>
              <td className="width1 checkbox-wrapper">
                <div data-code-barcode={barcodeString}
                    className={`checkbox multiproduct${['click', 'scan_click'].includes(product_confirmation_method) && !scanRequired ? ' clickable' : ''}`}
                    data-bundle-item-qty={item.qty_uom}
                      onClick={(event) =>
                        handleBundleCheckboxClick(event, item, parent, scan_bundle_element_as_single_qty, bundle_select, toggleConfirmButton)
                      }>
                    <Check className="check"/>
                </div>
              </td>
            </tr>)
        })}
        </tbody>
      </table>
    </div>
  )
}